import { cn } from "@bentolabs/kit/utils";
import BoringAvatar from "boring-avatars";

type Props = { name: string; className?: string };

export const Avatar = (props: Props) => {
  const { className, name } = props;
  return (
    <BoringAvatar
      colors={["#90C928", "#F180A6", "#C7555F"]}
      variant="pixel"
      name={name}
      className={cn("size-7", className)}
    />
  );
};
